import { useState, useEffect, useCallback, useRef } from 'react';
import { FetchMoreData } from '../components/controls/table-view';
import { ApplicationSort } from '../models/shared/application-sort';

interface UseInfiniteScrollOptions {
    dataLength: number;
    totalCount: number;
    fetchData?: FetchMoreData,
    loading: boolean;
    loadingRowRef: React.RefObject<HTMLDivElement>;
    searchText?: string;
    sortColumn?: string;
    sortOrder?: ApplicationSort;
}

export const useInfiniteScroll = ({
    dataLength,
    totalCount,
    fetchData,
    loading,
    loadingRowRef,
    searchText,
    sortColumn,
    sortOrder,
}: UseInfiniteScrollOptions) => {
   useEffect(() => {
    if (!loadingRowRef.current || !fetchData) return;

    const observer = new IntersectionObserver(
        (entries) => {
            const entry = entries[0];

            if (entry?.isIntersecting && dataLength < totalCount && !loading) {
                fetchData({
                    searchText,
                    sortColumn,
                    sortOrder,
                    reset: false,
                });
            }
        },
        {
            root: null,
            rootMargin: "1000px 0px", // preload 600px before loader is visible
            threshold: 0,
        }
    );

    const current = loadingRowRef.current;
    observer.observe(current);

    return () => {
        observer.unobserve(current);
    };
}, [
    dataLength,
    totalCount,
    loading,
    fetchData,
    searchText,
    sortColumn,
    sortOrder,
]);
};
